import React, { useState, useEffect } from 'react';
import { isSubAccount } from '../../consts/multiAccountConfig';
const TIPS_VERSION = 7;
const PREFIX = '__cache_system_tips_readed';

const getTips = () => {
  const { originRole } = window.pageProps;
  const hasPrivilege = ['OPERATOR_ROLE_LEADS_MANAGER', 'OPERATOR_ROLE_LEADS_CMANAGER', 'OPERATOR_ROLE_LEADS_OBSERVER', 'OPERATOR_ROLE_LEADS_SUPER_OBSERVER'].includes(originRole)
    && !isSubAccount();
  const tips = [
    () => {
      return (
        <div className="tips-item">
          <p>重要通知：因系统升级，部分客户对线索进行状态变更时可能会出现实际状态和显示状态不一致现象，请按以下指引清除缓存后重新操作：</p>
          <p>PC端：浏览器隐私设置模块-清除缓存；移动端：上划清除小程序及微信浏览痕迹，重新打开微信进入小程序。</p>
        </div>
      );
    },
    hasPrivilege ? () => {
      const jumpUrl = 'https://doc.weixin.qq.com/sheet/e3_AbAAfwaZAJQqCxfyiffQvCVBWz4yk';
      return (
        <div className="tips-item">
          <span>自2022.8.15起，用户留资短信触达功能将以广告主名义下发短信，不再以【腾讯科技】名义下发。因短信签名需要报备运营商审核，为不影响使用该功能，请广告主于2022.8.12 18:00之前联系腾讯内部运营同学申报广告主短信签名统一审核，逾期提交申请审核将有延迟。</span>
          <a href={jumpUrl} target="_blank" rel="noopener noreferrer">查看申报链接</a>
        </div>
      );
    } : undefined,
    hasPrivilege ? () => {
      const jumpUrl = '#/system/leadsManageSetting/recycle';
      return (
        <div className="tips-item">
          <div className="tips-icon"></div>
          {/* <span style={{ color: '#313233', fontWeight: 500, marginRight: 4 }}>服务商人员线索数据默认开启加密功能</span> */}
          <span>
            线索回收认领功能上线啦！支持（超级）管理员手动或者设置自动回收规则，避免因客服长时间未跟进线索错过了高效跟进的最佳机会。针对回收后的线索，支持管理者重新分配或同一团队客服主动认领实现线索跟进效率及效果最大化。
          </span>
          <a href={jumpUrl}>马上体验！</a>
        </div>
      );
    } : undefined,
    () => {
      const pdfUrl = 'https://leads.gdtimg.com/qzone/biz/gdt/leads-cdn/doc/internet_phone_helper.pdf';
      return (
        <div className="tips-item">
          <span>网络电话上线啦！打电话操作更简单，无需使用客服手机号，避免封号烦恼；用户来电显示号码是手机号，提升接通率。</span>
          <a target="_blank" href={pdfUrl} rel="noreferrer">操作指引</a>
        </div>
      );
    },
  ];
  return tips.filter(ele => ele !== undefined);
};

// 获取提示信息的初始状态
const init = () => {
  const cachedVersion = +localStorage.getItem(`${PREFIX}_VERSION`) || 0;
  if (cachedVersion >= TIPS_VERSION) return;
  // 如果缓存的版本比目前的版本低，肯定需要重新展示提示
  // 清缓存的时候不能全部清掉，只能清理包含PREFIX的
  // 为了防止一边遍历localstorage一边清理会导致key访问index乱序的问题，先拿到所有的itemName
  const needToClear = [];
  const reg = new RegExp(`^${PREFIX}`);
  for (let i = 0; i < localStorage.length; i++) {
    const itemName = localStorage.key(i);
    if (!reg.test(itemName)) continue;
    needToClear.push(itemName);
  }
  needToClear.forEach((itemName) => {
    localStorage.removeItem(itemName);
  });
  // 完了记得设置当前的提示版本为最新的
  localStorage.setItem(`${PREFIX}_VERSION`, TIPS_VERSION);
};
init();

let timer = null;
const TipsBar = () => {
  const TIPS = getTips();
  const [tips, setTips] = useState(TIPS);
  const [show, setShow] = useState(false);
  const [current, setCurrent] = useState(0);
  const showAutoTipsChange = () => {
    if (timer) clearInterval(timer);
    timer = setInterval(() => {
      setCurrent((c) => (c + 1) % tips.length);
    }, 5000);
  };

  useEffect(() => {
    const accountId = window.pageProps.uid;
    if (!accountId) return;
    const readed = localStorage.getItem(`${PREFIX}_${accountId}`);
    setShow(readed !== 'true');
    if (timer) clearInterval(timer);
    showAutoTipsChange();
    return () => {
      if (timer) clearInterval(timer);
    };
  }, [showAutoTipsChange]);

  const handleCloseTips = () => {
    const accountId = window.pageProps.uid;
    localStorage.setItem(`${PREFIX}_${accountId}`, 'true');
    setShow(false);
    if (timer) clearInterval(timer);
  };

  const handlePrevClick = () => {
    setCurrent((current + tips.length - 1) % tips.length);
    showAutoTipsChange();
  };

  const handleNextClick = () => {
    setCurrent((current + 1) % tips.length);
    showAutoTipsChange();
  };

  const CurrentTip = tips[current];

  if (!show) return null;

  return (
    <div className="system-tips">
      {tips.length > 1 && (
        <div className="pager">
          <div className="pager-btn prev" onClick={handlePrevClick}></div>
          <span>{current + 1}</span>
          <span>/</span>
          <span>{tips.length}</span>
          <div className="pager-btn next" onClick={handleNextClick}></div>
        </div>
      )}
      <CurrentTip key={current} />
      <div className="tips-closer" onClick={handleCloseTips}></div>
    </div>
  );
};

export default TipsBar;
